<template lang="pug">
  .mask(v-show="show")
    .modal(:style="modalStyle"
      :class="modalClass")
      slot(name="header")
      .divider
      slot(name="body")
      div.modal-buttons
        slot(name="buttons")
</template>

<script>
export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    modalStyle: {
      type: [Array, Object],
      default: () => {},
    },
    modalClass: {
      type: [Array, Object],
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.mask {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
  background-color: rgba(black, 0.3);
}

.modal {
  display: block;
  background-color: white;
  padding: 2rem 2rem;
  border: 1px solid #efeee6;
  z-index: 500;
  overflow-y: auto;
  width: 30rem;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  box-shadow: 3px 3px 3px rgba(black, 0.3);
}

.divider {
  width: 100%;
  border: 1px solid #efeee6;
}

.modal-buttons {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 2rem;

  button {
    margin-left: 1rem;
  }
}
</style>
